"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductTreeNode = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useProductTreeNode = ({ id }) => {
    const _a = (0, react_2.useQuery)(gql_1.GET_PRODUCT_TREE_NODE, { variables: { nodeId: id }, skip: !id }), { data } = _a, response = __rest(_a, ["data"]);
    const enrichedData = (0, react_1.useMemo)(() => {
        const { productTreeNode } = data !== null && data !== void 0 ? data : {};
        if (!productTreeNode) {
            return null;
        }
        const { descendants } = productTreeNode, restProductTreeNode = __rest(productTreeNode, ["descendants"]);
        return Object.assign(Object.assign({}, restProductTreeNode), { isTerminalNode: (descendants === null || descendants === void 0 ? void 0 : descendants.totalCount) === 1 });
    }, [data]);
    return Object.assign({ data: enrichedData }, response);
};
exports.useProductTreeNode = useProductTreeNode;
